import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState("productSkus", { metadata: undefined }, []),
};

const editProductSkuSuccess = (state, draft, payload) => {
  const index = state.productSkus.findIndex((r) => r.id === payload.id);
  if (index >= 0) {
    draft.productSkus[index] = payload;
  }
  draft.openDialog = false;
};

const skuProductCreatedSuccess = (state, draft, payload) => {
  const productSkus = state.productSkus || [];
  draft.productSkus = [...productSkus, payload];
  draft.openDialog = false;
};

const skuProductDeleteSuccess = (state, draft, payload) => {
  const productSkus = state.productSkus || [];
  draft.productSkus = productSkus.filter((a) => a.id != payload.id);
  draft.openDeleteDialog = false;
};

const showDialog = (state, draft, payload) => {
  draft.openDialog = true;
};

const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};

const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "getAllProductSkus",
    stateName: "productSkus",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "createProductSku",
    stateName: "productSku",
    async: true,
    isPaginated: false,
    successCb: skuProductCreatedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editProductSku",
    stateName: "productSku",
    async: true,
    isPaginated: false,
    successCb: editProductSkuSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "deleteProductSku",
    stateName: "productSku",
    async: true,
    isPaginated: false,
    successCb: skuProductDeleteSuccess,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDialog",
    stateName: "showDialog",
    async: false,
    isPaginated: false,
    successCb: showDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: false,
    successCb: resetDialog,
  }),
});
